export const SideMenuDataStation = {
  1: {
    name: "Dashboard",
    icon: "fa-solid fa-gauge",
    link: "/",
    AccessCode: "",
    requireStationId: true,
  },
  2: { label: "Fuel Stations Works" },
  3: {
    name: "Fuel Categories",
    icon: "fa-solid fa-layer-group",
    link: "/fuel_categories/fuel_categories_page",
    AccessCode: "VIEW-CATES",
    requireStationId: true,
  },
  4: {
    name: "Fuel Tanks",
    icon: "fa-solid fa-oil-can",
    link: "/fuel_tanks/fuel_tanks_page",
    AccessCode: "VIEW-TANKS",
    requireStationId: true,
  },
  5: {
    name: "Fuel Pumps",
    icon: "fa-solid fa-gas-pump",
    link: "/fuel_pumps/fuel_pumps_page",
    AccessCode: "VIEW-PUMPS",
    requireStationId: true,
  },
  6: {
    name: "Fuel Prices",
    icon: "fa-solid fa-tag",
    link: "/fuel_prices/fuel_prices_page",
    AccessCode: "VIEW-PRICES",
    requireStationId: true,
  },
  7: {
    name: "Fuel Deliveries",
    icon: "fa-solid fa-truck",
    link: "/deliveries/view_deliveries",
    AccessCode: "VIEW-INVENTORY-REPO",
    requireStationId: true,
  },
  8: {
    name: "Monthly Inventory Flow",
    icon: "fa-solid fa-warehouse",
    link: "/inventory/month_inventory_flow",
    AccessCode: "VIEW-INVENTORY-REPO",
    requireStationId: true,
  },
  9: {
    name: "Fuel Sales",
    icon: "fa-solid fa-chart-line",
    link: "#",
    requireStationId: true,
    subMenu: [
      {
        name: "View Recent Sales",
        link: "/sales/view_recent_sales",
        AccessCode: "VIEW-SALES-REPO",
        requireStationId: true,
      },
      {
        name: "Monthly Attendants Sales",
        link: "/sales/monthly_attendant_sales",
        AccessCode: "VIEW-SALES-REPO",
        requireStationId: true,
      },
    ],
  },
  10: {
    name: "Station Users",
    icon: "fa-solid fa-users",
    link: "/station_users/View_users",
    AccessCode: "VIEW-STATION-USER",
    requireStationId: true,
  },
  11: {
    name: "Shifts MGT",
    icon: "fa-solid fa-calendar-days",
    link: "#",
    requireStationId: true,
    subMenu: [
      {
        name: "Shift Templates",
        link: "/shifts/shift_templates",
        AccessCode: "ADD-SHIFT-T",
        requireStationId: true,
      },
      {
        name: "View Shift Allocations",
        link: "/shift/View_shift_allocations",
        AccessCode: "VIEW-SHIFT_A",
        requireStationId: true,
      },
    ],
  },
  12: {
    name: "Attendance MGT",
    icon: "fa-solid fa-user-check",
    link: "#",
    requireStationId: true,
    subMenu: [
      {
        name: "Sign In Attendant",
        link: "/attendence/sign_inn_attendant",
        AccessCode: "SIGN_IN-ATTEN",
        requireStationId: true,
      },
      {
        name: "Sign out Attendant",
        link: "/attendence/active_sessions",
        AccessCode: "SIGN_OUT-ATTEN",
        requireStationId: true,
      },
      {
        name: "View Attendance Report",
        link: "/attendence/Daily_attendence_report",
        AccessCode: "VIEW-ATTEN-REPO",
        requireStationId: true,
      },
    ],
  },
};
